import React from 'react'
import "../Styles/Tour_information.css"
import { NavLink, Outlet } from 'react-router-dom'

function Tour_information() {
  return (
    <div className='tourInfo_container'>
      <h2 className='tourInfo_title'>Hotel Information</h2>
      <div className='tourInfo_card'>
        <div className='tourInfo_section_navber' style={{overflowX:"auto"}}>
          <NavLink to={"/profile/activity-info"} end className={({ isActive }) => 
              isActive ? "tourInfo_link active" : "tourInfo_link" 
            }>
            Upcoming
          </NavLink>
          <NavLink to={"/profile/activity-info/passed"} className={({ isActive }) =>
              isActive ? "tourInfo_link active" : "tourInfo_link"
            }>
            Past
          </NavLink>

        </div>
        <hr/>
        {/* tour info content */}
        <div>
          <Outlet/>
        </div>
        </div>
    </div>
  )
}

export default Tour_information